export enum PipelineView {
    Deal = 'deal',
    Class = 'class',
    KMatrix = 'k-matrix'
}

// Backward compatibility for old IM links
export type ImDealsViewModeQueryStringParam = 'deal' | 'class' | 'kMatrix';

export function convertImDealViewModeQueryStringParamToEnum(param: ImDealsViewModeQueryStringParam | PipelineView) {
    switch (param.toLowerCase()) {
        case 'class':
            return PipelineView.Class;
        case PipelineView.KMatrix:
        case 'kMatrix'.toLowerCase():
            return PipelineView.KMatrix;
        default:
            return PipelineView.Deal;
    }
}

export function convertPipelineViewToExportedFromKey(view: PipelineView) {
    switch (view) {
        case PipelineView.Deal:
            return 'deal';
        case PipelineView.Class:
            return 'class';
        case PipelineView.KMatrix:
            return 'kMatrix';
        default: return '';
    }
}